import { request } from './api.js';
import type { Profile, UpdateProfileInput } from '../types/profile.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business プロフィールAPIクライアント。getProfile/updateProfileメソッドでログイン中ユーザー自身のプロフィール（GitHub ユーザー ID）を取得・更新する
 * @graph-connects /profile [calls] プロフィール取得・更新API
 * @graph-connects request [calls] 汎用フェッチラッパー呼び出し
 */
export const profileApi = {
  getProfile: (): Promise<Profile> => {
    return request<Profile>('/profile');
  },
  updateProfile: (data: UpdateProfileInput): Promise<Profile> => {
    return request<Profile>('/profile', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
};
